import environment from '@/modules/cart/environments/environment';
import httpClient from '@/modules/cart/services/api/client';
import type { shippingMethodBodyRequest } from '@/modules/shippingMethod/domain/ShippingMethodRepository';
import type { HttpShippingMethodDto } from '@/modules/shippingMethod/infrastructure/dto/HttpShippingMethodDto';

const { CART_URL } = environment;

export const getShippingGrouping = async (
  params: shippingMethodBodyRequest[] | undefined,
  cartId: string
): Promise<{
  data: HttpShippingMethodDto;
}> => {
  return await httpClient.post(
    `${CART_URL}/shipping-methods-grouping`,
    {
      lineItems: params ?? []
    },
    {
      headers: {
        'x-cart-id': cartId
      }
    }
  );
};
